import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { MEETING_READ, MEETING_SETTINGS, MEETING_WRITE } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function guarded(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

/** ログイン後（シェルの中・ModuleGate の下） */
export const meetingIngestRoutes: RouteObject[] = [
  { path: '/meeting-ingest', lazy: guarded(() => import('./pages/MeetingListPage.js'), MEETING_READ) },
  { path: '/meeting-ingest/upload', lazy: guarded(() => import('./pages/MeetingUploadPage.js'), MEETING_WRITE) },
  { path: '/meeting-ingest/record/new', lazy: guarded(() => import('./pages/MeetingRecordPage.js'), MEETING_WRITE) },
  { path: '/meeting-ingest/live/new', lazy: guarded(() => import('./pages/LiveMeetingCreatePage.js'), MEETING_WRITE) },
  { path: '/meeting-ingest/decisions', lazy: guarded(() => import('./pages/DecisionListPage.js'), MEETING_READ) },
  { path: '/meeting-ingest/action-items', lazy: guarded(() => import('./pages/ActionItemListPage.js'), MEETING_READ) },
  { path: '/meeting-ingest/settings', lazy: guarded(() => import('./pages/MeetingSettingsPage.js'), [...MEETING_SETTINGS, 'meeting-ingest.meeting.manage']) },
  // 事業者（Zoom / Teams / Meet）の同意画面からの戻り先。ログイン済みの画面が code / state を API に渡す（decisions §B）
  { path: '/meeting-ingest/oauth/:provider', lazy: guarded(() => import('./pages/OAuthCallbackPage.js'), ['meeting-ingest.integration.manage']) },
  // ★ 切り出しの共有 URL（ログイン必須・見えるかどうかは会議の visibility に従う）は :id より先
  { path: '/meeting-ingest/clips/:token', lazy: guarded(() => import('./pages/ClipPage.js'), MEETING_READ) },
  { path: '/meeting-ingest/meetings/:id', lazy: guarded(() => import('./pages/MeetingDetailPage.js'), MEETING_READ) },
];

/** ログイン不要の社外ゲスト参加ページ。 */
export const meetingIngestPublicRoutes: RouteObject[] = [
  { path: '/meet/:token', lazy: async () => ({ Component: (await import('./pages/MeetingGuestPage.js')).default }) },
];
